import React from 'react';
import CircularProgressMUI from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  caption: {
    fontFamily: 'MuseoSans',
    fontWeight: 300,
  },
});

export default function Progress(props) {
  const classes = useStyles();
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgressMUI
        variant="static"
        size={250}
        thickness={5}
        {...props}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        {props.variant !== 'indeterminate' && (
          <Typography variant="h1" color="primary">{`${Math.round(
            props.value
          )}%`}</Typography>
        )}
        <Typography variant="h2" className={classes.caption}>
          {props.caption}
        </Typography>
      </Box>
    </Box>
  );
}

Progress.propTypes = {
  value: PropTypes.number,
  caption: PropTypes.string,
  variant: PropTypes.oneOf(['determinate', 'indeterminate', 'static']),
};
